import { Suspense, useMemo } from "react";
import Layout from "./core/components/Layout/Layout";
import Routes from "./routes/Routes";
import { routeMap } from "./routes/routeMap";
import { MenuInterface, AppRouteInterface } from "./types";
import StorageUtil from "@utils/storageUtil";
import { authProps } from "@utils/viewUtility";
import version from "majorVersion";
import { useAppSelector } from "@utils/reduxUtil";

const getUserMenuAndRoutes = (permissions: string[]) => {
	const menuMap: { [key: string]: MenuInterface } = {};
	const routes: AppRouteInterface[] = [];

	permissions.forEach((permission) => {
		const menu = routeMap[permission];
		const route = routeMap[permission];
		if (menu) {
			if (menu.subMenus) {
				if (!menuMap[menu.menuLabel]) {
					menuMap[menu.menuLabel] = { ...menu, subMenus: [] };
				}
				menu.subMenus.forEach((subMenu) => {
					if (!menuMap[menu.menuLabel].subMenus?.some((sm) => sm.path === subMenu.path)) {
						menuMap[menu.menuLabel].subMenus?.push(subMenu);
					}
				});
			} else {
				menuMap[menu.menuLabel] = menu;
			}
		}

		if (route) {
			routes.push(route);
		}
	});
	const menu = Object.values(menuMap);

	return { menu, routes };
};

const Main = () => {
	const majorVersion = StorageUtil.getData(authProps.MAJOR_VERSION);
	if (!majorVersion || Number(majorVersion) < version) {
		StorageUtil.removeAll();
		StorageUtil.saveData(authProps.MAJOR_VERSION, String(version));
	}
	const { userInfo } = useAppSelector((state) => ({
		userInfo: state.auth.userInfo,
	}));

	const { menu, routes } = useMemo(() => {
		return userInfo ? getUserMenuAndRoutes(userInfo.permissions) : { menu: [], routes: [] };
	}, [userInfo]);

	return (
		<Layout menu={menu}>
			<Suspense fallback={<></>}>
				<Routes routes={routes} />
			</Suspense>
		</Layout>
	);
};

export default Main;
